module.exports = __webpack_public_path__ + "img/detail_trade.ace41883.png";